import script from "./MovementReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./MovementReportView.vue?vue&type=script&setup=true&lang=js"

import "./MovementReportView.vue?vue&type=style&index=0&id=74dce730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74dce730"]])

export default __exports__